import { LINKS } from '../constants';

type LogoMakerLinkEventNameBase = (typeof LINKS)[keyof typeof LINKS]['mixpanel'];

export const mixpanelInteractionEvent = (mixpanel: LogoMakerLinkEventNameBase) => ({
    eventName: 'Logo Maker - Header Menu - Interaction',
    eventData: { Item: mixpanel },
});
